/*
 * @Desc: api接口统一管理
 * @Author: 赵佳明
 * @Date: 2023-01-30 09:11:04
 * @LastEditors: 赵佳明
 * @LastEditTime: 2023-02-02 15:03:25
 * Copyright (c) 2023 山木枝(河北)技术服务有限公司, All Rights Reserved. 
 */
// import axios from './http.js'
import common from './common/common.js';
import index from './m/index.js';

const api = {
    common,
    index,

};

export default api;
